import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { StorageType } from '../../../../features/storages/types'
import { getAllStorageTypes } from '../../../../features/storages'

export type StoragesSliceState = {
  scrollTopPx: number
  searchQuery: string
  visibleTypes: StorageType[]
}

export const initialState: StoragesSliceState = {
  scrollTopPx: 0,
  searchQuery: '',
  visibleTypes: getAllStorageTypes()
}

export const slice = createSlice({
  name: 'storages',
  initialState,
  reducers: {
    setScrollTopPx: (state, action: PayloadAction<number>) => {
      state.scrollTopPx = action.payload
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload
    },
    addVisibleStorage: (state, action: PayloadAction<StorageType>) => {
      const storageType = action.payload
      if (!state.visibleTypes.includes(storageType)) {
        state.visibleTypes.push(storageType)
      }
    },
    removeVisibleStorage: (state, action: PayloadAction<StorageType>) => {
      state.visibleTypes = state.visibleTypes.filter(visibleType => visibleType !== action.payload)
    }
  }
})

export const actions = slice.actions
export const reducer = slice.reducer
